import React from 'react';
import LessonHome from '../LessonHome';

const Lesson13 = (props) => {

    return ( 
        <LessonHome
            {...props}
        />        
     );
}
 
export default Lesson13;